import React from 'react'

import WaitingAnimation from '../../order-status/components/WaitingAnimation'


export default function MigratrionLoadingPage({firstName}) {
    
    const thankYouText = firstName ? `Thank you, ${firstName}!` : 'Thank you!'

    return (
        <div className='migration-status-loading-container'>
            <div className='migration-status-loading-content'>
                <WaitingAnimation size={256} />
                <h2 className='thank-you-header'>{thankYouText}</h2>
                <p>Your subscription is migrating from</p>
                <p>CrumplePop to Boris FX Hub</p>
            </div>
        </div>
    )
}